import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  actions as upcomingSurveysActions,
  paginatedActions as upcomingSurveysPaginatedActions,
} from '../../redux/surveys/upcoming';
import {
  actions as answeredSurveysActions,
  paginatedActions as answeredSurveysPaginatedActions,
} from '../../redux/surveys/answered';
import { targetUserIdSelector } from '../../redux/context/selectors';
import {
  answeredListSelector,
  selectUpcomingList,
  selectAnsweredListSending,
  selectUpcomingSending,
  selectAnsweredListCounter,
  selectUpcomingListCounter,
} from '../../redux/surveys/selectors';
import styles from './index.styl';

const mapStateToProps = state => ({
  answeredList: answeredListSelector(state),
  upcomingList: selectUpcomingList(state),
  answeredListCounter: selectAnsweredListCounter(state),
  upcomingListCounter: selectUpcomingListCounter(state),
  answeredSending: selectAnsweredListSending(state),
  upcomingSending: selectUpcomingSending(state),
  targetUserId: targetUserIdSelector(state),
});
const mapDispatchToProps = {
  fetchUpcomingSurveys: upcomingSurveysActions.send,
  fetchAnsweredSurveys: answeredSurveysActions.send,
  loadNextUpcomingReq: upcomingSurveysPaginatedActions.loadNextRequests,
  loadNextAnsweredReq: answeredSurveysPaginatedActions.loadNextRequests,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ answeredSending, upcomingSending }) => ({
    loading: answeredSending || upcomingSending,
  })),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/DataSurveys/enhance.js